import { Form, Skeleton, Button, Row, Col, Radio, Card, ConfigProvider } from 'antd';
import { userActions } from '../../redux/actions/userAction';
import SubmitBtn from '../shared/SubmitBtn';
import InputField from '../shared/InputField';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import happyCallRepo from '../../repository/happyCallRepo';
import handleRsponse from '../../helper/handleRsponse';
const RegisterHappyCall = (props) => {


    //#region variables
    const headerString = `دوست عزیز از اینکه با تکمیل این پرسشنامه ما را در بهبود خدمات پس از فروش امرسان یاری میکنید. سپاسگزاریم`;
    const formRef = React.createRef();
    const [isLoaded, setIsLoaded] = useState(true);
    const [showSkeleton, setShowSkeleton] = useState(false);
    const [currentServiceNo, setCurrentServiceNo] = useState();
    const [commentReq, setCommentReq] = useState(false);
    const [questionList, setQuestionList] = useState([]);
    //const btnSave = useRef();
    //#endregion
    //#region events
    useEffect(() => {
        // console.log(props.history.location.state.serviceNo, 'history');
        let serviceNo = props.history.location.state.serviceNo;
        setCurrentServiceNo(serviceNo);
        handleRsponse.handleAxios(happyCallRepo.getQuestionList(`serviceNo=${serviceNo}`), fillQuestionList, setIsLoaded);
    }, []);
    //#endregion
    //#region Methods
    const fillQuestionList = (response) => {
        let qa = handleRsponse.getResponse(response);
        qa.forEach(element => { element.answerList = JSON.parse(element.answerList); });
        console.log(qa, 'question response');
        setQuestionList(qa);
        setShowSkeleton(true);
    }
    const onFinish = (values) => {
        setCommentReq(values['1000'] == 1000);
        let saveObject = { serviceNo: currentServiceNo, followUpComment: values['followUpComment'], questionList: [] };
        questionList.forEach(q => {
            console.log(q, 'q');
            saveObject.questionList.push({ 'questionId': q.id, 'answerId': values[q.id] });
        })
        //btnSave.current.setLoading();
        handleRsponse.handleAxios(happyCallRepo.registerHappyCall(saveObject, props.currentUser.token), null, setIsLoaded);
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const setRequired = (event) => {
        setCommentReq(event.target.value == 1000);
    }
    //#endregion
    const answers = (questionId) => questionList.find(x => x.id == questionId).answerList
        .map((item, i) => {
            return (
                <div>
                    {/* <input type="radio" name={'rb_' + questionId} value={item.id} /><span key={item.id}>{item.title}</span> */}
                    <Radio onChange={setRequired} value={item.id}> {item.title}</Radio>
                </div>
            )
        })
    const list = (questionList != null) ? questionList.map((item, i) => {
        return (
            <div key={item.id}>
                <b>{item.title}</b>
                <Form.Item name={item.id}
                    rules={[{ required: true, message: 'لطفا یک مورد را انتخاب نمایید' }]}
                >
                    <Radio.Group>
                        {answers(item.id)}
                    </Radio.Group>
                </Form.Item>

                <hr />
            </div>
        )
    }) : '';
    return (

        <ConfigProvider direction="rtl">
            <Card>
                <Skeleton loading={!showSkeleton}>
                    <center>
                        <h4>{headerString}</h4>
                        <br />
                        <p><b>{'شماره سرویس:' + currentServiceNo}</b></p>
                    </center>
                    <Form
                        ref={formRef}
                        name="basic"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        {list}
                        <InputField name="followUpComment" label="توضیحات پیگیری" placeholder="توضیحات پیگیری" inputType='TextArea' req={commentReq} />

                        <Form.Item
                            wrapperCol={{
                                offset: 0,
                            }}
                        >
                            <SubmitBtn label='ثبت'  loading={!isLoaded} />
                        </Form.Item>
                    </Form>
                </Skeleton>
            </Card>
        </ConfigProvider>

    )

}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    cc: state.user.currentCustomerInfo,
    serviceTypeId: state.user.currentServiceTypeId,
    currentMobile: state.user.currentMobile,
    currentUser: state.user.currentUser
});
const mapActionCreateor = {
    //setCustomer: userActions.updateCurrentCustomer,
    updateCurrentUser: userActions.setCurrentUser,
}
export default connect(mapStateToProps, mapActionCreateor)(RegisterHappyCall)